export const imageUrl = 'https://asset01.pakathukadai.com'
export const videoUrl = 'https://asset01.pakathukadai.com/ecomtamil'
export const baseUrl = 'https://wholesaleapi.ecomtamil.in'; // Production
//export const baseUrl = 'http://localhost:5005'; // Local development

export const apiUrls = {

   verifyuser: '/ecomwholesale/auth/verifyuser',
   registeruser: '/ecomwholesale/auth/registeruser',
   verifypassword: '/ecomwholesale/auth/verifypassword',
   getnewsletter: '/ecomcourse/newsletter/getnewsletter',
   createcategory: '/ecomcourse/category/createcategory',
   getcategory: '/ecomcourse/category/getcategory',
   getlevels: '/ecomcourse/level/getlevels',
   createlevel: '/ecomcourse/level/createlevel',
   getcurrentwebinar: '/ecomcourse/webinar/getcurrentwebinar',
   getcourse: '/ecomcourse/course/getcourse',
   coursecreate: '/ecomcourse/course/coursecreate',
   courseupdate: '/ecomcourse/course/courseupdate',
   coursedelete: '/ecomcourse/course/coursedelete',
   getincompleteservice: '/ecomcourse/service/getincompleteservice',
   updateserviceregister: '/ecomcourse/service/updateserviceregister',
   createserviceregister: '/ecomcourse/service/createserviceregister',
   gethistorywebinar: '/ecomcourse/webinar/gethistorywebinar',
   getcurriculams: '/ecomcourse/curriculam/getcurriculams',
   createcurriculams: '/ecomcourse/curriculam/createcurriculam?uploadId=testing',
   updatecurriculam: '/ecomcourse/curriculam/updatecurriculam',
   deletecurriculam: '/ecomcourse/curriculam/deletecurriculam',
   testing: '/ecomcourse/curriculam/progress/testing',
   getcompletedservices: '/ecomcourse/service/getcompletedservices',
   createwebinar: '/ecomcourse/webinar/createwebinar',
   updatewebinar: '/ecomcourse/webinar/updatewebinar',
   deletenewsletter: '/ecomcourse/newsletter/deletenewsletter',
   getservicelogs: '/ecomcourse/service/getservicelogs',
   updatecurriculamorder: '/ecomcourse/curriculam/updatecurriculamorder',
   coursemakeorder: '/ecomcourse/courseorder/coursemakeorder',
   verifycoursepayment: '/ecomcourse/courseorder/verifycoursepayment',
   createwebinarregistration: '/ecomcourse/webinarregistration/createwebinarregistration',
   getwebinarregistration: '/ecomcourse/webinarregistration/getwebinarregistration',
   updatewebinarregistration: '/ecomcourse/webinarregistration/updatewebinarregistration',
   coursepaymentinfo: '/ecomcourse/courseorder/coursepaymentinfo',
   getcoursepaymentinfo: '/ecomcourse/courseorder/getcoursepaymentinfo',
   addcurriculamvariant:'/ecomcourse/curriculamvideo/addvideoattachment',
   getvideoattachments:'/ecomcourse/curriculamvideo/getvideoattachments',
   getattachmentfile:'/ecomcourse/curriculamvideo/getfile',
   deletecurriculamvariant:'/ecomcourse/curriculam/deletecurriculamvariant',
   getmycourseorders:'/ecomcourse/courseorder/getmycourseorders',
   saveprogress:'/ecomcourse/videoprogress/saveprogress',
   getprogress:'/ecomcourse/videoprogress/getprogress',
   resetprogress:'/ecomcourse/videoprogress/resetprogress',
   webinarmakeorder:'/ecomcourse/webinarorder/webinarmakeorder',
   verifywebinarpayment:'/ecomcourse/webinarorder/verifywebinarpayment',
   webinarpaymentinfo:'/ecomcourse/webinarorder/webinarpaymentinfo',
   getwebinarpaymentinfo:'/ecomcourse/webinarorder/getwebinarpaymentinfo',
   getwebinarorderbydate:'/ecomcourse/webinarorder/getwebinarorderbydate',
   createmissioncard:'/ecomcourse/missioncard/createmissioncard',
   deletemissioncard:'/ecomcourse/missioncard/deletemissioncard',
   getmissioncard:'/ecomcourse/missioncard/getmissioncard',
   updatemissioncard:'/ecomcourse/missioncard/updatemissioncard',
   getallcousers: '/ecomcourse/cousers/getallcousers',
   createcourseaccess: '/ecomcourse/courseaccess/createcourseaccess',
   getcourseaccess: '/ecomcourse/courseaccess/getcourseaccess',
   updatecourseaccess: '/ecomcourse/courseaccess/updatecourseaccess',
   deletecourseaccess: '/ecomcourse/courseaccess/deletecourseaccess',
   getcommunityposts: '/ecomcourse/community/getposts',
   getcommunityReplies: '/ecomcourse/community/getreplies',
   createcommunitypost: '/ecomcourse/community/createpost',
   createcommunityreply: '/ecomcourse/community/createreply',
   upvotecommunitypost: '/ecomcourse/community/votepost',
   upvotecommunityreply: '/ecomcourse/community/votereply',
   getcommunitydashboardstats: '/ecomcourse/community/getdashboardstats',
   getmyposts: '/ecomcourse/community/getmyposts',
   pinpost: '/ecomcourse/community/pinpost',
   updatecommunitypost: '/ecomcourse/community/updatepost',
   deletecommunitypost: '/ecomcourse/community/deletepost',
}